import { render } from "./ManagerActions.vue?vue&type=template&id=4e097831&scoped=true"
import script from "./ManagerActions.vue?vue&type=script&lang=js"
export * from "./ManagerActions.vue?vue&type=script&lang=js"

import "./ManagerActions.vue?vue&type=style&index=0&id=4e097831&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e097831"]])

export default __exports__